/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { ChangeCustomerOrderWorkflowStatusDto } from '../../models/change-customer-order-workflow-status-dto';
import { OrderCustomerItemEssential } from '../../models/order-customer-item-essential';

export interface OrderCustomerControllerChangeCustomerOrderWorkflowStatus$Params {
  id: number;
      body: ChangeCustomerOrderWorkflowStatusDto
}

export function orderCustomerControllerChangeCustomerOrderWorkflowStatus(http: HttpClient, rootUrl: string, params: OrderCustomerControllerChangeCustomerOrderWorkflowStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: OrderCustomerItemEssential;
}>> {
  const rb = new RequestBuilder(rootUrl, orderCustomerControllerChangeCustomerOrderWorkflowStatus.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: OrderCustomerItemEssential;
      }>;
    })
  );
}

orderCustomerControllerChangeCustomerOrderWorkflowStatus.PATH = '/order-customer/change-customer-order-status/{id}';
